<template>
  <base-dialog v-bind="$attrs" :dialogVisible="dialogVisible" width="628px"
               @handleClose="handleClose" @handleConfirm="handleConfirm" :show-close="false">
    <template #title>{{$t('common.edit')}}</template>
    <el-form ref="editorCorpusForm" :model="formData" :rules="rules" label-width='80px'>
      <el-form-item ref="editorName" class="bankName-form-item"
                    :class="{'en-form-item_label':$i18n.locale==='en'}" size="small"
                    :label="$t('termBankV2.bankName')" prop="name">
        <el-input style="width:100%;" v-model="formData.name" @input="changeinput"
                  :placeholder="$t('memoryBankV2.pleaseInputActivity')">
        </el-input>
      </el-form-item>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item ref="editorSource" :class="{'en-form-item_label':$i18n.locale==='en'}"
                        size="small" :label="$t('newProjectV2.sourceLang')" prop="sourceLang">
            <el-select disabled v-model="formData.sourceLang"
                       :placeholder="$t('memoryBankV2.pleaseLanguage')">
              <el-option v-for="item in langOptions" :key="item.sourceLang"
                         :label="$i18n.locale==='zh'?item.sourceLangName:getEnlang(item.sourceLang)"
                         :value="item.sourceLang">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item ref="editorTarget" :class="{'en-form-item_label':$i18n.locale==='en'}"
                        size="small" :label="$t('newProjectV2.targetLang')" prop="targetLang">
            <el-select disabled v-model="formData.targetLang"
                       :placeholder="$t('memoryBankV2.pleaseTargetLanguage')">
              <el-option v-for="item in langOptions" :key="item.sourceLang"
                         :label="$i18n.locale==='zh'?item.sourceLangName:getEnlang(item.sourceLang)"
                         :value="item.sourceLang">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 领域 -->
      <el-form-item class="domain-form-item" size="small" :label="$t('termBankV2.domainNoColon')"
                    prop="domainCode">
        <el-select v-model="formData.domainCode" :placeholder="$t('memoryBankV2.pleaseDomain')">
          <el-option v-for="(item,index) in domainOptions" :key="index"
                     :label="$i18n.locale==='zh'?item.dataDesc:getEnDomain(item.dataKey)"
                     :value="item.dataKey"></el-option>
        </el-select>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item size="small" :label="$t('termBankV2.remark')" prop="remark">
        <el-input style="width:100%;" :rows="3" resize="none" type="textarea"
                  v-model="formData.remark" :placeholder="$t('memoryBankV2.pleaseInputRemark')">
        </el-input>
      </el-form-item>
    </el-form>
    <template #confirm>{{$t('projectDetailsV2.save')}}</template>
  </base-dialog>
</template>

<script>
// 术语库编辑api
import { uploadTerm } from "@/services/term";
// 记忆库编辑api
import { uploadMemory } from "@/services/memoryBank";
import { getLang, getOptionList } from '@/services/memoryBank';

export default {
  name: 'EditCorpus',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    bankType: {
      type: String,
      default: ''
    },
    corpusDetailInfo: {
      type: Object,
      default: () => { }
    },

  },
  data () {
    return {
      formData: {
        domainCode: "",
        // domainName: "",
        sourceLang: '',
        targetLang: '',
        name: "",
        remark: "",
      },
      rules: {
        name: [
          { required: true, message: this.$t('termBankV2.pleaseInputActivity'), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('termBankV2.WithinSixteenLength'), trigger: 'blur' }
        ],
        sourceLang: [
          { required: true, message: this.$t('newProjectV2.sourceLangTip'), trigger: 'change' },
        ],
        targetLang: [
          { required: true, message: this.$t('newProjectV2.targetLangTip'), trigger: 'change' }
        ],
        domainCode: [
          { required: true, message: this.$t('termBankV2.pleaseDomain'), trigger: 'change' }
        ],
        remark: [
          { min: 0, max: 140, message: this.$t('termBankV2.WithinFiftyLength', [140]), trigger: 'blur' }
        ]
      },
      // 下拉列表
      options: {
        langOptions: [],
        domainOptions: []
      },
    }
  },
  computed: {
    domainOptions () {
      return this.options.domainOptions || []
    },
    langOptions () {
      return this.options.langOptions || []
    }
  },
  watch: {
    dialogVisible: {
      handler (newVal) {
        if (!newVal) return
        this.getLangList({ type: 1 })
        this.getDomainList()
        this.$nextTick(() => {
          const editorNameLabel = this.$refs.editorName.$el.childNodes[0]
          const editorSourceLabel = this.$refs.editorSource.$el.childNodes[0]
          const editorTargetLabel = this.$refs.editorTarget.$el.childNodes[0]
          editorNameLabel.setAttribute('label-data', editorNameLabel.innerText)
          editorSourceLabel.setAttribute('label-data', editorSourceLabel.innerText)
          editorTargetLabel.setAttribute('label-data', editorTargetLabel.innerText)
          for (const key in this.formData) {
            if (Object.hasOwnProperty.call(this.corpusDetailInfo, key)) {
              this.formData[key] = this.corpusDetailInfo[key]
            }
          }
        })
      }
    }
  },

  methods: {
    changeinput () {
      this.formData.name = this.formData.name.replace(/^\s*/g, '');
    },
    // 获取语言
    async getLangList (params) {
      const { success, result } = await getLang(params)
      if (!success) return
      this.options.langOptions = result
    },

    // 获取领域
    async getDomainList () {
      const params = {
        dataType: 'trans_domain'
      }
      const { success, result } = await getOptionList(params)
      if (!success) return
      this.options.domainOptions = result
    },

    handleClose () {
      this.$refs.editorCorpusForm.resetFields()
      this.$emit('handleClose');
    },

    async handleConfirm () {
      this.$refs.editorCorpusForm.validate(async (validate) => {
        if (!validate) return
        const { name, domainCode, remark, id } = this.corpusDetailInfo
        if (this.formData.name === name && this.formData.domainCode === domainCode && this.formData.remark === remark) {
          this.$emit('handleConfirm', false);
          return
        }
        const params = {
          id,
          domainCode: this.formData.domainCode,
          domainName: this.domainOptions.find(item => item.dataKey === this.formData.domainCode).dataDesc,
          name: this.formData.name,
          remark: this.formData.remark
        }
        const fn = this.bankType === 'memory' ? uploadMemory : uploadTerm
        const { success } = await fn(params)
        if (!success) return
        this.$message.closeAll()
        this.$message.success(this.$t("termBankV2.editSuccess"))
        this.$emit('handleConfirm', true);
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  padding-bottom: 10px;
}
/deep/.el-dialog__body {
  margin-top: 6px;
  padding: 0 60px;
  box-sizing: border-box;
  .el-form-item__content {
    text-align: left;
  }
  .el-textarea__inner {
    height: 130px;
  }
  .domain-form-item .el-input__inner {
    width: 162px;
  }

  .en-form-item_label {
    position: relative;
    &::before {
      position: absolute;
      width: 0px;
      height: 0px;
      left: 36px;
      top: -1px;
      opacity: 0;
      transition: opacity 0.3s;
      border: 5px solid transparent;
      border-top-color: #303133;
    }
    .el-form-item__label {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &::after {
        position: absolute;
        content: attr(label-data);
        width: auto;
        padding: 0px 5px;
        left: -6%;
        top: -32px;
        opacity: 0;
        min-height: 22px;
        background: #303133;
        transition: opacity 0.3s;
        color: #fff;
        z-index: 100;
        font-size: 12px;
        border-radius: 4px;
      }
    }
    &:hover::before {
      opacity: 1;
    }
    &:hover .el-form-item__label::after {
      opacity: 1;
    }
  }
  .bankName-form-item {
    &::before {
      left: 26px;
    }
    .el-form-item__label {
      &::after {
        left: -2%;
      }
    }
  }
}
/deep/.el-dialog__footer {
  margin-top: 6px;
  padding-bottom: 30px;
}
</style>